<div class="absolute inset-0">
    <!-- This page should display nothing -->
</div>
